import 'bootstrap/dist/css/bootstrap.min.css'
import MostValuablePlayers from './partials/MostValuablePlayers'
import MiniLeagues from './partials/MiniLeagues'
import SquadRanking from "./partials/SquadRanking";
import React, {useEffect, useState} from "react";
import {Container, Row, Col} from 'reactstrap';
import _ from "./Trans";
import ReactGA from "react-ga4";
import Config from "./Config";

const headerClasses = 'mb-3 h4 font-weight-bold ranking-header';
const hide = {display: 'none'}
const show = {display: 'block'}
const weeklyTitle = _('Last round ranking');
const title = _('Ranking');
const miniLeaguesTitle = _('Mini leagues')

export default function Ranking({squad, navbar, isMobile, tournament}) {
    useEffect(() => {
        ReactGA.initialize(Config.GA_CODE);
        ReactGA.send({hitType: "pageview", page: "/ranking/", title: "Ranking"});
    }, []);

    const [activeMenu, setActiveMenu] = useState(1)

    const selectMenu = function(menu) {
        setActiveMenu(menu);
    }

    const [active, setActive] = useState('active')
    const removeActive = function(e) {
        setActive('')
    }

  return (<div>
    <Container>
        {isMobile ? "" : navbar}
    <Row id="menu">
    <Col xs={4} className={"text-center link" && active} onClick={() => selectMenu(1)} onMouseOut={removeActive}>
        <h3 className={headerClasses} data-menu="1">{weeklyTitle}</h3>
    </Col>
    <Col xs={4} className="text-center link" onClick={() => selectMenu(2)}>
        <h3 className={headerClasses} data-menu="2">{title}</h3>
    </Col>
    <Col xs={4} className="text-center link" onClick={() => selectMenu(3)}>
        <h3 className={headerClasses} data-menu="3">{miniLeaguesTitle}</h3>
    </Col>
    </Row>
      <SquadRanking weekly={true} name={squad.name} points={squad.points_last_week} position={squad.this_week_position} totalTeams={squad.total_teams} display={activeMenu === 1 ? show : hide} tournament={tournament}/>
      <SquadRanking name={squad.name} points={squad.total_points} position={squad.global_position} totalTeams={squad.total_teams} display={activeMenu === 2 ? show : hide} tournament={tournament}/>
      <MiniLeagues display={activeMenu === 3 ? show : hide}/>
      <MostValuablePlayers/>
    </Container>
      </div>
  )
}
